import { EMPTY_PATH, BACKOFFICEMAIN_PATH, CHANGE_PASSWORD_PATH } from "../../crossconcern/utilities/properties/path.property";
import { BackofficeMainComponent } from "./backofficemain";
import { BACKOFFICEMAIN_ROUTES } from "./backofficemain/backofficemain.routes";
import { PRIVATE_CHANGE_PASSWORD_ROUTE } from "../../crossconcern/utilities/properties/routename.property";
import { ChangePasswordComponent } from "./changePassword";
import { BackofficeGuardHelper } from "../../crossconcern/helpers/generic/backofficeguard.helper";
var ɵ0 = { routeName: PRIVATE_CHANGE_PASSWORD_ROUTE };
export var BACKOFFICE_ROUTES = [
    {
        path: EMPTY_PATH,
        pathMatch: "full",
        redirectTo: BACKOFFICEMAIN_PATH
    },
    {
        path: BACKOFFICEMAIN_PATH,
        component: BackofficeMainComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        children: BACKOFFICEMAIN_ROUTES
    },
    {
        path: CHANGE_PASSWORD_PATH,
        component: ChangePasswordComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ0
    }
];
export { ɵ0 };
